<template>
  <t-option
    class="tlbs-option"
    v-bind="$attrs"
  >
    <slot />
  </t-option>
</template>

<script lang="ts" setup name="TlbsOption">
</script>
